import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { DEFAULT_INTERRUPTSOURCES, Idle } from '@ng-idle/core';
import { merge, of, pipe } from 'rxjs';
import { filter, switchMap, tap } from 'rxjs/operators';
import { TokenService } from '../../auth/services/token.service';
import { AuthState } from '../../shared/models/auth/auth-state.model';
import { AuthStoreService } from '../../shared/services/auth/auth-store.service';
import { IdleLoggedOutComponent } from '../components/idle-logged-out/idle-logged-out.component';
import { IdleWarningComponent } from '../components/idle-warning/idle-warning.component';
import { AppConfig } from './app-config.service';
import { SavedUrlService } from './saved-url.service';
import { ContentDataService } from '../../liabilities/services/content-data.service';

@Injectable({
  providedIn: 'root',
})
export class IdleService {
  private idleSnackbarRef: MatSnackBarRef<IdleWarningComponent>;
  private loggedOutRef: MatSnackBarRef<IdleLoggedOutComponent>;

  constructor(
    private appConfig: AppConfig,
    private router: Router,
    private auth: AuthStoreService,
    private contentStoreService: ContentDataService,
    private idle: Idle,
    private snackbar: MatSnackBar,
    private tokenService: TokenService,
    private savedUrlService: SavedUrlService,
  ) {
  }

  get isIdleMode(): boolean {
    return !this.tokenService.rememberMe;
  }

  public init(): void {
    merge(of(this.auth.state), this.auth.state$)
      .pipe(this.onAuthStateChangePipe())
      .subscribe();
    this.idle.onIdleStart.pipe(this.onIdleStartPipe()).subscribe();
    this.idle.onInterrupt.pipe(this.onIdleInterruptPipe()).subscribe();
    this.idle.onTimeout.pipe(this.onIdleTimeoutPipe()).subscribe();
  }

  private onAuthStateChangePipe(): any {
    return pipe(
      tap((state: AuthState) => {
        if (state === AuthState.AUTHENTICATED) {
          if (this.isIdleMode) {
            this.startIdle();
          }
          if (!!this.loggedOutRef) {
            this.loggedOutRef.dismiss();
          }
        }

        if (state === AuthState.NOT_AUTHENTICATED) {
          this.idle.stop();
        }
      }),
    );
  }

  private startIdle(): void {
    this.idle.setInterrupts(DEFAULT_INTERRUPTSOURCES);
    this.idle.setIdle(this.appConfig.config.idle.waitBefore);
    this.idle.setTimeout(this.appConfig.config.idle.timeout);
    this.idle.watch();
  }

  private onIdleStartPipe(): any {
    return pipe(
      filter(() => this.isIdleMode),
      // tap(() => (this.idleSnackbarRef = this.snackbar.openFromComponent(IdleWarningComponent))),
    );
  }

  private onIdleInterruptPipe(): any {
    return pipe(
      filter(() => !!this.idleSnackbarRef),
      tap(() => this.idleSnackbarRef.dismiss()),
    );
  }

  private onIdleTimeoutPipe(): any {
    return pipe(
      filter(() => this.isIdleMode),
      switchMap(() => this.auth.logout()),
      tap(()=>{
        this.contentStoreService.clear();
      }),
      tap(() => {
        this.savedUrlService.clear();
        this.idleSnackbarRef.dismiss();
        // this.loggedOutRef = this.snackbar.openFromComponent(IdleLoggedOutComponent);
      }),
    );
  }
}
